import React, { useEffect, useState } from 'react';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import { loadStripe } from '@stripe/stripe-js';
import FullLayout2 from '../asyncIntake/screens/components/FullLayout';
import { measureHeight } from 'react-div-100vh';
import withAnalytics from '../../lib/withAnalytics';
import { ExplorePlans } from './components/ExplorePlans';
import { ComponentWrap } from './components/ComponentWrap';
import { SingleSelect } from './components/SingleSelect';
import { Steps, Step, Wizard } from 'react-albus';
import { GoalTransition } from './components/GoalTransition';
import { Flex } from 'rebass';
import theme from '../../styles/theme';
import { GoalReassurance } from './components/GoalReassurance';
import { Eligible1 } from './components/Eligible1';
import { HeightWeight } from './components/HeightWeight';
import { Bmi } from './components/Bmi';
import { LoggedInExperiencedDiagnosed, OPTIONS as OPTIONS_DIAGNOSED } from './components/ExperiencedDiagnosed';
import { ConditionsNext, OPTIONS as OPTIONS_CONDITIONS_NEXT } from './components/ConditionsNext';
import { OPTIONS as OPTIONS_CONDITIONS } from './components/Conditions';
import { Results } from './components/Results';
import { CHARTS, CURRENT_USER, MEMBERSHIP_CREATE_SESSION } from '../../graphql';
import { ConditionsLoggedIn } from './components/ConditionsLoggedIn';
import { Cancer } from './components/Cancer';
import withSession from '../../lib/withSession';
import { LearnMoreModal } from '../asyncIntake/screens/LearnMoreModal';
import { sleep } from '../../utils/sleep';

const Pb = styled(Flex)`
  transition: all 0.35s ease;
`;

const Container = styled(Flex)`
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

const STEPS_CONTROL = [
  {
    id: 'welcome',
    set: [],
    requisite: [],
  },
  {
    id: 'weightLossGoal',
    set: ['weightLossGoal'],
    requisite: [],
  },
  {
    id: 'goals-transition',
    set: [],
    requisite: ['weightLossGoal'],
  },
  {
    id: 'goals-reassurance',
    set: [],
    requisite: ['weightLossGoal'],
  },
  // {
  //   id: 'select-state',
  //   set: ['prestate'],
  //   requisite: ['weightLossGoal'],
  // },
  // {
  //   id: 'dob',
  //   set: ['dob'],
  //   requisite: ['weightLossGoal', 'prestate'],
  // },
  // {
  //   id: 'sex-at-birth',
  //   set: ['assignedsexatbirth'],
  //   requisite: ['weightLossGoal', 'prestate', 'dob'],
  // },
  {
    id: 'height-weight',
    set: ['feet', 'inches', 'pounds', 'bmi'],
    requisite: ['weightLossGoal'],
  },
  {
    id: 'previous-glp1',
    set: ['previousGlp1'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'glp1-stopped',
    set: ['stoppedGlp1'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', 'previousGlp1'],
  },
  {
    id: 'bmi',
    set: [],
    requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'experience-or-diagnosed',
    set: ['_diagnosis'],
    requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi'],
  },
  {
    id: 'conditions',
    set: ['_conditions1'],
    requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis'],
  },
  {
    id: 'conditions-next',
    set: ['_conditions2'],
    requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1'],
  },
  {
    id: 'good-to-go',
    set: [],
    requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
  },
  // {
  //   id: 'results',
  //   set: [],
  //   requisite: ['weightLossGoal', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
  // },
];

const Inner = ({ history, location, analytics, client, session, redirectTo, basePath = 'wlm', onFailRedirectTo }) => {
  const vh100 = `${measureHeight()}px` || '100vh';
  const [step, setStep] = useState(0);
  const [state, setState] = useState(window.sessionStorage.getItem('wmi') !== null ? JSON.parse(window.sessionStorage.getItem('wmi')) : {});
  const [previousPage, setPreviousPage] = useState();
  const [learnMoreModal, setLearnMoreModal] = useState(null);

  const checkRequisites = () => {
    const locat = STEPS_CONTROL.find((x) => x.id === location.pathname.replace(`/${basePath}/`, ''));
    if (!locat) {
      return;
    }
    for (let index = 0; index < locat.requisite.length; index++) {
      const element = locat.requisite[index];
      if (element.indexOf('_') === 0) {
        if (element === '_diagnosis') {
          const opts = OPTIONS_DIAGNOSED;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/${basePath}/${target.id}`);
          }
        }
        if (element === '_conditions1') {
          const opts = OPTIONS_CONDITIONS;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/${basePath}/${target.id}`);
          }
        }
        if (element === '_conditions2') {
          const opts = OPTIONS_CONDITIONS_NEXT;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            history.replace(`/${basePath}/${target.id}`);
          }
        }
        continue;
      }
      if (state[element]) {
        // console.log('found')
      } else {
        console.log('notFound');
        const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
        if (!target) continue;
        history.replace(`/${basePath}/${target.id}`);
      }
    }
  };
  useEffect(() => {
    const rem = async () => {
      await sleep(500);
      if (window.Beacon) {
        window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      } else {
        await sleep(3000);
        if (window.Beacon) {
          window.Beacon('on', 'ready', () => window.Beacon('destroy'));
        }
      }
      await sleep(3000);
      try {
        window.Beacon('destroy');
      } catch (error) {}
    };

    rem();
  }, []);

  useEffect(
    () => {
      if (location.pathname !== previousPage) {
        let tag = (location.pathname || '').replace(`/${basePath}`, '');
        if (location.pathname.indexOf('basic') > -1) {
          tag = 'basic';
        } else if (location.pathname.indexOf('profile') > -1) {
          tag = 'profile';
        } else if (location.pathname.indexOf('extended') > -1) {
          tag = 'extended';
        }
        if (tag) {
          analytics.page(tag, `/${basePath}`);
        }
        setPreviousPage(location.pathname);
        checkRequisites();
      }
    },
    [location]
  );

  const handleChange = (id, value, clearValue) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;
    if (!!clearValue) {
      if (Array.isArray(clearValue)) {
        for (let index = 0; index < clearValue.length; index++) {
          const element = clearValue[index];
          delete s[element];
        }
      } else {
        delete s[clearValue];
      }
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeMultiple = (idValues) => {
    const s = JSON.parse(JSON.stringify(state));
    for (let index = 0; index < idValues.length; index++) {
      const element = idValues[index];
      const { id, value } = element;
      s[id] = value;
    }

    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeHeightWeight = (id, value) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;
    if (s['feet'] && (s['inches'] || s['inches'] === 0) && s['pounds']) {
      let centimeters = (parseInt(s['feet'] || 0, 10) * 12 + parseInt(s['inches'] || 0, 10)) * 2.54;
      let grams = parseFloat((s['pounds'] || '').replace(/ /g, '') || '0') * 453.6;

      const bmi = ((grams / 1000 / centimeters / centimeters) * 10000).toFixed(2);
      s['bmi'] = bmi;
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const goToPurchase = async () => {
    let priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_WEIGHT_LOSS;
    const createSession = await client.mutate({
      mutation: MEMBERSHIP_CREATE_SESSION,
      variables: {
        priceId: priceId,
        forwardUrl: '',
        cancel_url: '/',
        trial: false,
      },
    });

    const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
    const stripe = await stripePromise;
    await stripe.redirectToCheckout({
      sessionId: createSession.data.createCheckoutSession.sessionId,
    });
  };

  const determineNextFromDiagnosed = () => {
    if (state['bmi'] < 22) {
      window.localStorage.setItem('wm-d', 'stateOrBMI');
      return 'conditions';
    }

    if (state['bmi'] > 27) {
      return 'conditions';
    }

    if (state['previousGlp1']==='neverGlp1' || state['previousGlp1']==='moreThan3Months') {
      console.log(3)
      //disqualify GLP1
      window.localStorage.setItem('wm-d', 'bmi');
      // return 'results';
    }

    return 'conditions';
  };

  const onCancer = () => {
    let resp = '';
    if (state[`papillaryYou`]) {
      resp += 'papillary; ';
    }
    if (state[`follicularYou`]) {
      resp += 'follicular; ';
    }
    if (state[`medullaryYou`]) {
      resp += 'medullary; ';
    }
    if (state[`anaplasticYou`]) {
      resp += 'anaplastic; ';
    }
    if (state[`carcinomaYou`]) {
      resp += 'carcinoma; ';
    }
    const questionId = window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '297' : '301';
    const answer = 'Y';
    const value = resp;

    client.mutate({
      mutation: CHARTS,
      variables: {
        data: [
          {
            endpoint: 'medicalHistory',
            values: [
              {
                questionId,
                answer,
                value,
              },
            ],
          },
        ],
        intakeStatus: '',
        intakeType: 'weightloss',
      },
      refetchQueries: [{ query: CURRENT_USER }],
      awaitRefetchQueries: true,
    });
  };

  return (
    <FullLayout2
      style={{
        zIndex: 11,
        overflowY: 'auto',
        maxHeight: '',
        paddingLeft: location.pathname !== `/${basePath}/results` ? '12px' : 0,
        paddingRight: location.pathname !== `/${basePath}/results` ? '12px' : 0,
      }}
      pb={5}
    >
      <Container
        style={{
          maxWidth: location.pathname !== `/${basePath}/results` ? '600px' : '',
          // height: 'auto !important',
          minHeight: vh100,
          overflow: 'hidden',
        }}
      >
        <Wizard
          history={history}
          basename={`/${basePath}`}
          render={({ step, ...p }, a) => {
            // console.log({ p, a, step });
            return (
              <>
                <Flex flexDirection={'row'} style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }} pt={2} id="pgbar">
                  <Flex flexDirection={'row'} style={{ width: '100%', height: '6px' }}>
                    <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)' }} flex={1} id="ttt">
                      <Pb
                        flex={(p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length}
                        style={{ background: theme.color.pink, borderTopRightRadius: '3px', borderBottomRightRadius: '3px' }}
                      />
                      <Pb flex={1 - (p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length} style={{ background: 'transparent' }} />
                    </Flex>
                    <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                    <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                  </Flex>
                </Flex>
                <Steps>
                  <Step id="welcome">
                    <ComponentWrap>
                      <ExplorePlans onContinue={() => p.push('goals')} />
                    </ComponentWrap>
                  </Step>
                  <Step id="goals">
                    <ComponentWrap>
                      <SingleSelect
                        onChange={handleChange}
                        onContinue={() => p.push('goals-transition')}
                        id={'weightLossGoal'}
                        state={state}
                        title={`What’s your weight loss goal?`}
                        options={[
                          {
                            value: '1-15',
                            label: 'Losing 1-15 lbs',
                          },
                          {
                            value: '16-50',
                            label: 'Losing 16-50 lbs',
                          },
                          {
                            value: '51+',
                            label: 'Losing 51+ lbs',
                          },
                          {
                            value: 'notSure',
                            label: 'Not sure, I just need to lose weight',
                          },
                        ]}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="goals-transition">
                    <ComponentWrap>
                      <GoalTransition state={state} onContinue={() => p.push('goals-reassurance')} />
                    </ComponentWrap>
                  </Step>

                  <Step id="goals-reassurance">
                    <ComponentWrap>
                      <GoalReassurance state={state} onContinue={() => p.push('height-weight')} />
                    </ComponentWrap>
                  </Step>

                  {/* <Step id="select-state">
                    <ComponentWrap>
                      <PickState state={state} onChange={handleChange} onContinue={() => p.push('dob')} />
                    </ComponentWrap>
                  </Step>

                  <Step id="dob">
                    <ComponentWrap>
                      <Dob state={state} onChange={handleChange} onContinue={() => p.push('sex-at-birth')} />
                    </ComponentWrap>
                  </Step>

                  <Step id="sex-at-birth">
                    <ComponentWrap>
                      <SexAtBirth state={state} onChange={handleChange} onContinue={() => p.push('height-weight')} />
                    </ComponentWrap>
                  </Step> */}

                  <Step id="height-weight">
                    <ComponentWrap>
                      <HeightWeight
                        state={state}
                        onChange={handleChangeHeightWeight}
                        onContinue={() => {
                          const bmi = state['bmi'];
                          if(bmi<22){
                            p.push('experience-or-diagnosed');
                            return
                          }
                          if (bmi >= 22 && bmi < 27) {
                            p.push('previous-glp1');
                          } else {
                            p.push('bmi');
                          }
                        }}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="previous-glp1">
                    <ComponentWrap>
                      <SingleSelect
                        onChange={(id, value) => {
                          handleChangeMultiple([{ id, value }, { id: 'stoppedGlp1', value: null }]);
                        }}
                        onContinue={() => {
                          const previousGlp1 = state['previousGlp1'];

                          if (previousGlp1 !== 'stopped') {
                            p.push('experience-or-diagnosed');
                          } else {
                            p.push('glp1-stopped');
                          }
                        }}
                        id={'previousGlp1'}
                        state={state}
                        title={`Are you currently or have you ever taken a GLP-1 medication?`}
                        options={[
                          {
                            value: 'currentlyTakingGlp1',
                            label: 'I am currently taking a glp-1 medication',
                          },
                          {
                            value: 'stopped',
                            label: `I have taken a GlP-1 medication but I'm not currently`,
                          },
                          {
                            value: 'neverGlp1',
                            label: 'I have never took a GLP-1 medication',
                          },
                        ]}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="glp1-stopped">
                    <ComponentWrap>
                      <SingleSelect
                        onChange={handleChange}
                        onContinue={() => p.push('experience-or-diagnosed')}
                        id={'stoppedGlp1'}
                        state={state}
                        title={`When did you stop taking your last dose of GLP-1 Medication?`}
                        options={[
                          {
                            value: 'withinLast2weeks',
                            label: 'Within the last 2 weeks',
                          },
                          {
                            value: 'lessThan3months',
                            label: `More than 2 weeks and less than 3 months ago`,
                          },
                          {
                            value: 'moreThan3Months',
                            label: 'More than 3 months ago',
                          },
                        ]}
                      />
                    </ComponentWrap>
                  </Step>

                  <Step id="bmi">
                    <ComponentWrap>
                      <Bmi
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          p.push('experience-or-diagnosed');
                        }}
                      />
                    </ComponentWrap>
                  </Step>

                  <Step id="experience-or-diagnosed">
                    <ComponentWrap>
                      <LoggedInExperiencedDiagnosed state={state} onChange={handleChange} onContinue={() => p.push(determineNextFromDiagnosed())} />
                    </ComponentWrap>
                  </Step>

                  <Step id="conditions">
                    <ComponentWrap>
                      <ConditionsLoggedIn
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          if (state['pregnant'] || state['tryingpregnant'] || state['breastfeeding'] || state['diabetesInsulin']) {
                            window.localStorage.setItem('wm-d', 'conditions1');
                            p.push('results');
                            return;
                          }
                          p.push('hypo-cancer');
                        }}
                        //  onContinue={() => p.push('conditions-next')}
                      />
                    </ComponentWrap>
                  </Step>

                  <Step id="hypo-cancer">
                    <ComponentWrap>
                      <Cancer
                        target="You"
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          console.log({ state });
                          if (!state['noneCancerYou']) {
                            onCancer();
                          }
                          if (state['medullaryYou']) {
                            window.localStorage.setItem('wm-d', 'medullary');
                            p.push('results');
                            return;
                          } else if (!state['noneConditionsYou']) {
                            window.localStorage.setItem('wm-ds', 'disqualify-hypo');
                          }
                          p.push('family-hypo-cancer');
                        }}
                      />
                    </ComponentWrap>
                  </Step>

                  <Step id="family-hypo-cancer">
                    <ComponentWrap>
                      <Cancer
                        target="Family"
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          if (state['medullaryFamily']) {
                            window.localStorage.setItem('wm-d', 'medullary');
                            p.push('results');
                            return;
                          }
                          p.push('conditions-next');
                        }}
                      />
                    </ComponentWrap>
                  </Step>

                  <Step id="conditions-next">
                    <ComponentWrap>
                      <ConditionsNext
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          if (!state['noneConditionsNext']) {
                            window.localStorage.setItem('wm-d', 'conditions2');
                            p.push('results');
                            return;
                          }
                          p.push('results');
                        }}
                      />
                    </ComponentWrap>
                  </Step>

                  {/* <Step id="good-to-go">
                    <ComponentWrap>
                      <Eligible1 state={state} onChange={handleChange} onContinue={() => p.push('results')} />
                    </ComponentWrap>
                  </Step> */}

                  <Step id="results">
                    <Results
                      session={session}
                      state={state}
                      onChange={handleChange}
                      onFailRedirectTo={onFailRedirectTo}
                      showLearnMore={(learnMoreId) => setLearnMoreModal(learnMoreId)}
                      onContinue={(isFailed) => {
                        if (!!isFailed && onFailRedirectTo) {
                          history.push(onFailRedirectTo);
                          return;
                        }
                        console.log({ redirectTo });
                        const wmd = window.localStorage.getItem('wm-d');
                        console.log({ wmd });
                        if (wmd) {
                          history.push('/');
                          return;
                        }
                        if (!!redirectTo) {
                          window.localStorage.setItem('wlm-el', 'ok');
                          history.push(redirectTo);
                          return;
                        }
                        goToPurchase();
                      }}
                      isLoggedInMode={true}
                    />
                  </Step>
                </Steps>
              </>
            );
          }}
        />
      </Container>
      {learnMoreModal && <LearnMoreModal learnMoreId={learnMoreModal} onClose={() => setLearnMoreModal(null)} />}
    </FullLayout2>
  );
};

const LoggedInWeightLossPrequalification = ({ history, location, analytics, client, session }) => {
  return <Inner history={history} location={location} analytics={analytics} client={client} session={session} />;
};

export const LoggedInWeightLossPrequalificationSchedule_ = ({ history, location, analytics, client, session }) => {
  return (
    <Inner
      history={history}
      location={location}
      analytics={analytics}
      client={client}
      session={session}
      onFailRedirectTo={`/schedule-split`}
      // redirectTo={`/schedulewl${location.search.indexOf('?skp=true') > -1 ? '?skp=true' : ''}`}
      redirectTo={`/wlm-schedule-qualified${location.search.indexOf('?skp=true') > -1 ? '?skp=true' : ''}`}
      basePath="wlm-schedule"
    />
  );
};

export const LoggedInWeightLossPrequalificationBecomeMember_ = ({ history, location, analytics, client, session }) => {
  return (
    <Inner
      history={history}
      location={location}
      analytics={analytics}
      client={client}
      session={session}
      redirectTo={`/become-member?showRes=true`}
      onFailRedirectTo={`/become-member?showRes=true`}
      basePath="wlm-become-member"
    />
  );
};

export const LoggedInWeightLossPrequalificationSchedule = withAnalytics(withApollo(withRouter(withSession(LoggedInWeightLossPrequalificationSchedule_))));
export const LoggedInWeightLossPrequalificationBecomeMember = withAnalytics(withApollo(withRouter(withSession(LoggedInWeightLossPrequalificationBecomeMember_))));

export default withAnalytics(withApollo(withRouter(withSession(LoggedInWeightLossPrequalification))));
